module.exports = __webpack_public_path__ + "static/badgeTechreviewerBlockchain-ee9853b8bc1565b88902e59b40a70936.svg";